import { a } from '../global-constants';

const testParams = (state = false, { type, payload }) => {
	switch (type) {
		case a.SET_TEST_PARAMS: {
			return payload;
		}
		default:
			return state;
	}
};

export default testParams;
